import Entity from '@/models/entities/Entity';

export class Size implements Entity {
  public id: number = 0;
  public name: string = '';
  public description?: string = '';
  public position: number = 0;
  public additionalPrice?: number = 0;
  //deprecated since MKLS/TASK839: Remove PRO Heavy Weight option
  public proOption?: boolean = false;
  public minimumAmount?: number = 0;

  constructor(initData: Partial<Size>) {
    Object.assign(this, initData);
  }
}
